import { useCopyToClipboard } from '@modules/common/hooks';
import { useFetchTenantSSOSettings } from '@modules/workspaceSettings/hooks';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { IconButton, Link, Stack, Tooltip, Typography } from '@mui/material';

const AUTH_SECRET_LEARN_MORE_LINK =
  'https://helpcenter.enterpret.com/en/articles/6870807-using-single-sign-on-sso#h_27c450e807';

export const CopyAuthSecretButton = () => {
  const { ssoSettings } = useFetchTenantSSOSettings();
  const authSecret = ssoSettings?.authSecret;

  const copyTextToClipboard = useCopyToClipboard();

  if (!authSecret) {
    return null;
  }

  const onClick = () => {
    copyTextToClipboard(
      authSecret,
      `Authentication Secret copied to clipboard!`,
    );
  };

  return (
    <Tooltip
      arrow
      title={
        <Stack p={1}>
          <Typography variant="body2">
            Copy Authentication Secret. This can be used to set up automated
            user de-provisioning.{' '}
            <Link
              href={AUTH_SECRET_LEARN_MORE_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more.
            </Link>
          </Typography>
        </Stack>
      }
    >
      <IconButton onClick={onClick}>
        <ContentCopyRoundedIcon />
      </IconButton>
    </Tooltip>
  );
};
